import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Calendar, Trophy, Vote, MapPin, Shield, UserPlus, Star, Target, Search, DollarSign, MessageCircle } from 'lucide-react';
import Header from '../../components/layout/Header';

const features = [
  { icon: Search, title: 'Encontre seu Fut', desc: 'Busque peladas na sua cidade, veja vagas abertas e entre em jogos mesmo sem conhecer ninguém. Nunca mais fique sem jogar.' },
  { icon: Users, title: 'Grupos', desc: 'Crie ou participe de grupos de pelada. Grupos podem ser públicos ou privados com convite.' },
  { icon: Calendar, title: 'Agendamento', desc: 'Agende partidas com data, horário, local e preço. Jogos recorrentes são criados automaticamente.' },
  { icon: UserPlus, title: 'Presença', desc: 'Confirme presença, adicione jogadores avulsos e acompanhe quem vai jogar.' },
  { icon: Shield, title: 'Sorteio de Times', desc: 'Times equilibrados com 4 critérios: rating da galera, últimos jogos, nota do admin ou aleatório. Goleiro garantido em cada time. Times diferentes a cada sorteio.' },
  { icon: Vote, title: 'Votação', desc: 'Após a partida, avalie cada jogador de 1 a 10 por time. Craque e Bola Murcha são destacados automaticamente.' },
  { icon: Star, title: 'Rating', desc: 'Cada jogador tem um rating comunitário baseado nas votações. Quanto mais você joga, mais preciso fica.' },
  { icon: DollarSign, title: 'Financeiro', desc: 'Controle pagamentos, despesas com quadra e churras. Saldo atualizado por período (semanal ou mensal).' },
  { icon: MapPin, title: 'Vagas Abertas', desc: 'Admins podem abrir vagas para jogadores externos. Faltou gente? O app resolve.' },
  { icon: Users, title: 'Peladeiros Disponíveis', desc: 'Cadastre sua disponibilidade no perfil e apareça para outros jogadores da sua cidade que precisam completar o time.' },
  { icon: Trophy, title: 'Histórico & Classificação', desc: 'Acompanhe resultados, estatísticas e times de todas as partidas. Grupos com liga têm tabela de classificação estilo Brasileirão.' },
];

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header showBack onBack={() => navigate(-1)} />
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <div className="text-center">
          <img src="/icone.png" alt="Pelada Match" className="w-24 h-24 mx-auto mb-3" />
          <h1 className="text-2xl font-bold text-slate-800">pelada<span className="text-blue-500">match</span></h1>
          <p className="text-slate-400 text-sm mt-1">Seu fut, sempre rolando</p>
        </div>

        {/* Missão principal */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-5 text-white">
          <div className="flex items-start gap-3">
            <Target className="w-6 h-6 text-blue-200 shrink-0 mt-0.5" />
            <div>
              <h2 className="font-bold text-lg mb-2">Nossa Missão</h2>
              <p className="text-blue-100 text-sm leading-relaxed">
                Nenhuma pelada deveria deixar de acontecer por falta de jogador. O Pelada Match conecta
                quem organiza com quem quer jogar — para que todo mundo encontre seu fut e a bola nunca pare de rolar.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 p-5">
          <h2 className="font-bold text-slate-800 mb-3">O que é o Pelada Match?</h2>
          <p className="text-sm text-slate-500 leading-relaxed">
            Uma plataforma completa para peladas de futebol. Organize grupos, agende partidas,
            controle presença, sorteie times equilibrados, avalie jogadores e encontre novos jogos na sua cidade.
            Tudo em um só lugar, direto do celular.
          </p>
        </div>

        <div>
          <h2 className="font-bold text-slate-800 mb-4">Funcionalidades</h2>
          <div className="space-y-3">
            {features.map((f, i) => {
              const Icon = f.icon;
              return (
                <div key={i} className="flex gap-4 bg-white rounded-xl border border-slate-100 p-4">
                  <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center shrink-0">
                    <Icon className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-700 text-sm">{f.title}</h3>
                    <p className="text-xs text-slate-400 mt-0.5 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Sugestões */}
        <div className="bg-white rounded-2xl border border-slate-200 p-5">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center shrink-0">
              <MessageCircle className="w-5 h-5 text-emerald-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-slate-700 text-sm">Tem uma sugestão?</h3>
              <p className="text-xs text-slate-400 mt-1 leading-relaxed">
                Quer sugerir uma funcionalidade, reportar um bug ou só trocar uma ideia? Manda um zap!
              </p>
              <a
                href="https://wa.me/5551998642652?text=Fala%2C%20Yago!%20Tenho%20uma%20sugest%C3%A3o%2Fd%C3%BAvida%20no%20Pelada%20Match."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-3 px-4 py-2.5 bg-emerald-600 text-white text-sm font-bold rounded-xl hover:bg-emerald-700 transition-colors"
              >
                <MessageCircle className="w-4 h-4" /> Chamar no WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="text-center text-xs text-slate-300 pb-4">
          Pelada Match v2.4.0
        </div>
      </div>
    </>
  );
};

export default AboutPage;
